<template>
  <div>
    <h1>Customer Location</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'DEALER'"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <div class="mt-5" style="background-color: black; color:white; padding:0.5%;">
      <h3 style="margin:0;">CUSTOMER LOCATION</h3>
    </div>
    <!-- Customer Location Map Start -->
    <div class="innerBox mt-2">
      <customer-location-map
        :filterUrl="filterUrl"
      ></customer-location-map>
    </div>
    <!-- Customer Location Map End-->

    <!-- Customer Location By Category And Segment Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Customer Location By Category And Segment</h5>
      <customer-location-by-category-and-segment
        :filterUrl="filterUrl"
        @getSegment="setSubSeriesTypeFilter"
      ></customer-location-by-category-and-segment>
    </div>
    <!-- Customer Location By Category And Segment End -->

    <!-- Customer Location By Sub Series And Type Start -->
    <div class="innerBox mt-5" v-if="shown.subSeriesType">
      <h5 class="mb-2">Customer Location By Sub-Series And Type</h5>
      <customer-location-by-sub-series-and-type
        :filterUrl="subSeriesTypeFilterUrl"
        @getCodeMarket="setCodeMarketFilter"
      ></customer-location-by-sub-series-and-type>
    </div>
    <!-- Customer Location By Sub Series And Type End -->

    <!-- Customer Location By Code Market Start -->
    <div class="innerBox mt-5" v-if="shown.codeMarket">
      <h5 class="mb-2">Customer Location By Code (Market Name)</h5>
      <customer-location-by-code-market
        :filterUrl="codeMarketFilterUrl"
      ></customer-location-by-code-market>
    </div>
    <!-- Customer Location By Code Market End -->
  </div>
</template>

<script>
  import qs from 'qs'

  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import customerLocationMap from './children/customerLocationMap'
  import customerLocationByCategoryAndSegment from './children/customerLocationByCategoryAndSegment'
  import customerLocationBySubSeriesAndType from './children/customerLocationBySubSeriesAndType'
  import customerLocationByCodeMarket from './children/customerLocationByCodeMarket'

  export default {
    data () {
      return {
        filterUrl : '',
        subSeriesTypeFilterUrl : '',
        codeMarketFilterUrl : '',
        
        shown : {
          subSeriesType : false,
          codeMarket : false,
        },

        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      customerLocationMap,
      customerLocationByCategoryAndSegment,
      customerLocationBySubSeriesAndType,
      customerLocationByCodeMarket,
    },
    mounted () {
      this.fetchFilter++;
    },
    watch : {
      'filterUrl' : function(){
        this.subSeriesTypeFilterUrl = this.filterUrl;

        this.shown.subSeriesType = false;
        this.shown.codeMarket = false;
      }
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      },
      setSubSeriesTypeFilter(value){
        //load and create chart first (no data yet)
        this.shown.subSeriesType = true;

        var finalFilterUrl = this.filterUrl
        if(this.filterUrl.includes('segment')){
          let obj = qs.parse(this.filterUrl)
          obj['segment'] = `${obj['segment']},${value}`

          finalFilterUrl = qs.stringify(obj)
          finalFilterUrl = finalFilterUrl.replace(/%2C/g, ',')
        } else {
          finalFilterUrl = `${this.filterUrl}&segment=${value}`
        }
        setTimeout(()=>{
          this.subSeriesTypeFilterUrl = finalFilterUrl
          window.scrollTo(0, document.body.scrollHeight);
        }, 200)
      },
      setCodeMarketFilter(value){
        //load and create chart first (no data yet)
        this.shown.codeMarket = true;

        var finalFilterUrl = this.subSeriesTypeFilterUrl
        if(this.filterUrl.includes('type')){
          let obj = qs.parse(this.subSeriesTypeFilterUrl)
          obj['type'] = `${obj['type']},${value}`

          finalFilterUrl = qs.stringify(obj)
          finalFilterUrl = finalFilterUrl.replace(/%2C/g, ',')
        } else {
          finalFilterUrl = `${this.subSeriesTypeFilterUrl}&type=${value}`
        }
        setTimeout(()=>{
          this.codeMarketFilterUrl = finalFilterUrl
          window.scrollTo(0, document.body.scrollHeight);
        }, 200)
      }
    }
  }
</script>

<style scoped>
  
</style>